import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ny',
    fullName: 'Nyanja',
    nativeName: 'Nyanja',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Chinachake Chodabwitsa Chikubwera",
    landing_subtitle: "ArgVoid ndi pulogalamu yopangira masewera. Khalani tcheru, zinthu zatsopano zikubwera posachedwa!",
    select_language: "Sankhani Chiyankhulo",
    search_placeholder: "Sakani zilankhulo...",
    terms_title: "Terms of Service",
    policy_title: "mfundo zazinsinsi",
    cookies_title: "Ma cookie Policy",
    terms_content: `
        <strong>1. Kuvomereza Terms</strong><br>
        Pofikira ku ArgVoid, Migwirizano Yantchitoyi imavomerezedwa. Ngati mawuwa sanagwirizane, ntchitoyo siyenera kugwiritsidwa ntchito.<br><br>

        <strong>2. Platform Usage</strong>X<br>
        ArgVoid ndi ntchito zake zimaperekedwa "monga momwe ziliri" pazolinga zodziwitsa komanso kulenga. Ntchitoyi iyenera kugwiritsidwa ntchito pazovomerezeka zokha.<br>X<br>

        <strong>3. Makhalidwe Oletsedwa</strong><br>
        Kugwiritsa ntchito ziwopsezo zamasamba, kutumizirana ma spam, kapena kuyesa kugwiritsa ntchito malo osavomerezeka ndikoletsedwa.<br><br>

        <strong>4. Chithunzi cha </strong><br>
        Pulatifomu ndi ntchito zitha kusinthidwa nthawi iliyonse popanda kuzindikira. Palibe chitsimikizo choperekedwa chokhudza nthawi yowonjezera kapena kupezeka kwa ntchitoyo.
    `,
    policy_content: `
        <strong>1. Zosonkhanitsa Zambiri</strong><br>
        Pulatifomu sikufunika kutsimikizira kwa ogwiritsa ntchito kapena kupanga akaunti pakadali pano. Palibe chidziwitso chaumwini (monga mayina kapena ma adilesi a imelo) chomwe chimasonkhanitsidwa kuchokera kwa alendo.<br><br>

        <strong>2. Kugwiritsa ntchito Data</strong>X<br>
        Ma analytics oyambira, osadziwika atha kusonkhanitsidwa kuti mumvetsetse kuchuluka kwamasamba ndikuwongolera mapulogalamu. Izi sizikulumikizidwa ndi zomwe munthu akudziwa.<br>X<br>

        <strong>3. Ntchito Zachipani Chachitatu</strong><br>
        Opereka chipani chachitatu atha kugwiritsidwa ntchito pothandizira komanso kusanthula. Zochita zachinsinsi za operekera awa zimayendera data yosadziwika yomwe imakonzedwa pamaziko awo.<br><br>

        <strong>4. Chitetezo cha Data</strong><br>
        Njira zodzitetezera zimayendetsedwa kuti ziteteze nsanja. Komabe, palibe njira yotumizira pa intaneti yomwe ili yotetezeka kwathunthu.<br><br>
    `,
    cookies_content: `
        <strong>1. Kodi Ma Cookies and Local Storage ndi chiyani?</strong><br>
        Ma cookie ndi msakatuli wosungira kwanuko ndi mafayilo ang'onoang'ono a data omwe amasungidwa pachipangizo kukumbukira zokonda zanu paulendo uliwonse.<br><br>

        <strong>2. Kugwiritsa Ntchito Purpose</strong>X<br>
        Browser LocalStorage imagwiritsidwa ntchito mosamalitsa kusunga masinthidwe, monga:<br>
        - Zokonda chilankhulo<br>
        - Kusintha kwa mawonekedwe a ogwiritsa ntchito (mwachitsanzo, masanjidwe kapena masinthidwe amutu)<br>
        - Cache yogwiritsira ntchito kwakanthawi<br><br>

        <strong>3. Palibe Tracking</strong><br>
        Ma cookie ndi zosungira zakomweko sizigwiritsidwa ntchito kutsatsa kapena kutsata anthu ena. Deta yonse yosungidwa ndiyomwe imagwira ntchito papulatifomu.<br><br>

        <strong>4. Chithunzi cha</strong><br>
        Deta ya msakatuli ikhoza kuchotsedwa nthawi iliyonse kudzera pa zoikamo za msakatuli, zomwe zingakhazikitsenso masanjidwe apafupi.
    `,
    cookie_consent_text: "Timagwiritsa ntchito makeke ofunikira kuonetsetsa kuti tsamba lawebusayiti likugwira ntchito moyenera, monga kusunga gawo lanu, kusunga chilankhulo chomwe mumakonda, ndi masinthidwe ena.",
    read_policy: "Werengani Ma cookie Policy",
    support_title: "Lumikizanani ndi Thandizo",
    support_subject_label: "Mutu",
    support_message_label: "Uthenga",
    support_submit_button: "Tumizani Uthenga",
    support_hint: "Zindikirani: Izi zidzatsegula imelo yanu yokhazikika kuti mutumize uthengawo.",
    support_success_msg: "Kutsegula pulogalamu yanu ya imelo...",
    support_error_msg: "Zalephera kutumiza uthenga. Chonde yesaninso nthawi ina.",
    explorer_title: "Wofufuza",
    history_title: "Mbiri",
    animation_title: "Makanema",
    config_title: "Kusintha",
    tool_mouse: "Sankhani (Ctrl+M)",
    tool_brush: "Burashi (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Yolimba/Yomveka)",
    tool_eraser: "Chofufutira (Ctrl+E)",
    tool_brush_size: "Sinthani Kukula Kwa Burashi",
    tool_bucket: "Lembani (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Gridi (Ctrl+Shift+B)",
    tool_rotate: "Sinthani (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "M'lifupi",
    label_height: "Kutalika",
    label_frames: "Chiwerengero cha Mafelemu",
    label_animation: "Makanema kalembedwe",
    label_background_color: "Mtundu Wambuyo",
    label_interval: "Nthawi",
    tool_anim_config: "Makanema kasinthidwe",
    label_new_width: "Kukula Kwatsopano",
    label_new_height: "Kutalika Kwatsopano",
    label_apply: "Ikani",
    label_colors: "Mitundu",
    label_size: "Kukula",
    label_tolerance: "Kulekerera",
    val_horizontal: "Chopingasa",
    val_vertical: "Oima",
    val_sequence: "Kutsatizana",
    val_bounce: "Kudumpha",
    val_random: "Mwachisawawa",
    val_solid: "Zolimba",
    val_clear: "Zomveka",
    action_add_sheet: "Mapepala Atsopano",
    action_import: "Tengani",
    action_export: "Tumizani kunja",
    action_sort_projects: "Sinthani",
    sort_date_old: "Zakale Kwambiri",
    sort_date_new: "Chatsopano Choyamba",
    sort_name_az: "Dzina (A-Z)",
    sort_name_za: "Dzina (Z-A)",
    action_new_sprite: "Sprite Watsopano",
    action_new_project: "Ntchito Yatsopano",
    modal_save_all_title: "Sungani Zosintha Zonse",
    modal_save_all_desc: "Sankhani katundu kuti musunge:",
    modal_save_selected: "Sungani Zosankhidwa",
    action_saved: "Zosungidwa",
    modal_create_sprite_title: "Pangani Sprite Yatsopano",
    modal_create_project_title: "Pangani Ntchito Yatsopano",
    modal_add_sheet_title: "Onjezani Mapepala Atsopano",
    modal_rename_sheet_title: "Sinthani dzina Mapepala",
    modal_rename_sprite_title: "Sinthani dzina Sprite",
    modal_delete_sprite_title: "Chotsani Sprite",
    modal_delete_project_title: "Chotsani Project",
    modal_delete_sheet_title: "Chotsani Mapepala",
    placeholder_sprite_name: "Dzina",
    placeholder_project_name: "Dzina",
    placeholder_sheet_name: "Dzina",
    placeholder_new_name: "Dzina Latsopano",
    action_create: "Pangani",
    action_add: "Onjezani",
    action_rename: "Sinthani dzina",
    action_duplicate: "Zobwerezedwa",
    action_delete: "Chotsani",
    action_cancel: "Letsani",
    confirm_delete_sprite: "Mukutsimikiza kuti mukufuna kuchotsa sprite iyi?",
    confirm_delete_project: "Kodi mukutsimikiza kuti mukufuna kuchotsa polojekitiyi? Ma sprites onse adzachotsedwa.",
    confirm_delete_sheet: "Kodi mukutsimikiza kuti mukufuna kuchotsa pepalali?",
    err_select_sprite: "Chonde sankhani gulu kaye.",
    err_select_project: "Chonde sankhani polojekiti kaye.",
    err_name_empty: "Dzina silingakhale lopanda kanthu.",
    err_sprite_exists: "Gulu lomwe lili ndi dzinali lilipo kale.",
    err_project_exists: "Ntchito yokhala ndi dzinali ilipo kale.",
    err_no_content: "Palibe zosunga.",
    err_no_changes: "Palibe zosintha zomwe zingasungidwe.",
    err_delete_last_sheet: "Sitingathe kuchotsa pepala lomaliza.",
    err_extract_frames: "Sitinathe kuchotsa mafelemu aliwonse.",
    err_indexeddb: "Zalephera kusunga kwanuko. Msakatuli wanu sangathe kuthandizira IndexedDB.",
    msg_upload_success: "Kukwezera Kupambana: {0}",
    msg_upload_failed: "Kukwezera Kwalephereka: {0}",
    msg_save_success: "Sungani bwino.",
    msg_saving: "Kusunga...",
    msg_multi_save_result: "Zasungidwa {0}. {1} zolephera.",
    menu_title: "Menyu",
    menu_save: "Sungani",
    menu_save_all: "Sungani Zonse",
    menu_support: "Lumikizanani ndi Thandizo",
    label_local_storage: "Malo Osungirako",
    label_sign_in: "Lowani muakaunti",
    modal_export_title: "Tumizani kunja Sprite",
    label_filename: "Dzina lafayilo",
    label_format: "Mtundu",
    action_export_confirm: "Tumizani kunja",
};

export default translations;
